import SafeImage from '@ui/SafeImage';
import React from 'react';

const SoldOrDraftBlock = ({ variant }: { variant: 'sold' | 'draft' }) => {
  return (
    <div className="flex w-full items-center gap-[2rem] rounded-3xl bg-brand-secondary p-[2.4rem]">
      <SafeImage
        src="/sold-sign.svg"
        width={32}
        height={32}
        alt={'sold sign'}
      />
      <div className="flex w-full flex-col justify-center text-brand-white">
        <span className="text-[1.6rem] font-semibold">
          {variant === 'draft' ? 'Draft Listing' : 'Item Sold!'}
        </span>
        <span className="text-[1.4rem]">
          This item has recently been purchased.
        </span>
      </div>
    </div>
  );
};

export default SoldOrDraftBlock;
